"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = require("@pbl/pbl-react-core/lib/services");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var actions_1 = require("../../../redux/reducers/app/actions");
var actions_2 = require("../../../redux/reducers/authentication/actions");
var menu_1 = require("../menu");
var UpdateEmailConfirmForm_1 = __importDefault(require("./components/UpdateEmailConfirmForm"));
var UpdateEmailForm_1 = __importDefault(require("./components/UpdateEmailForm"));
var validations_1 = require("./validations");
var ChangeEmailScreen = function (_a) {
    var changeSection = _a.changeSection;
    var dispatch = (0, react_redux_1.useDispatch)();
    var account = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }).account;
    var _b = react_1.default.useState(''), newEmail = _b[0], setNewEmail = _b[1];
    var _c = react_1.default.useState(1), currentForm = _c[0], setCurrentForm = _c[1];
    var onSubmit = function (email) { return function () {
        setNewEmail(email);
        setCurrentForm(2);
    }; };
    var onSectionChance = function (key) {
        var menuItem = (0, menu_1.findInMenuItems)(key);
        if (menuItem) {
            changeSection(menuItem);
        }
    };
    var onCancel = function () {
        setNewEmail('');
        setCurrentForm(1);
        onSectionChance(menu_1.SettingsSectionKeys.ACCOUNT_SECURITY);
    };
    var onConfirm = function (currentPassword) { return function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    dispatch((0, actions_1.toggleLoading)({ spinning: true }));
                    return [4, services_1.AccountService.changeEmail(newEmail, currentPassword)];
                case 1:
                    _a.sent();
                    dispatch((0, actions_2.getAccount)());
                    dispatch((0, actions_1.showMessageBar)({ message: 'email.updated' }));
                    onSectionChance(menu_1.SettingsSectionKeys.ACCOUNT_SECURITY);
                    return [3, 4];
                case 2:
                    e_1 = _a.sent();
                    dispatch((0, actions_1.showMessageBar)({ message: e_1.payload.title, type: 'error' }));
                    return [3, 4];
                case 3:
                    dispatch((0, actions_1.clearLoading)());
                    return [7];
                case 4: return [2];
            }
        });
    }); }; };
    if (currentForm === 1) {
        return (react_1.default.createElement(UpdateEmailForm_1.default, { oldEmail: account.email, onSubmit: onSubmit, validationSchema: validations_1.emailValidationSchema }));
    }
    return (react_1.default.createElement(UpdateEmailConfirmForm_1.default, { oldEmail: account.email, newEmail: newEmail, onCancel: onCancel, onConfirm: onConfirm, validationSchema: validations_1.currentPasswordValidation }));
};
exports.default = ChangeEmailScreen;
//# sourceMappingURL=ChanceEmail.js.map